import {useState, useEffect} from 'react';

// Retrieves the featured card data from the DOM and sets it as a state to allow navigation in the modal.
const useFeaturedCardData = () => {
	const [modalContent, setModalContent] = useState([]);

	useEffect(() => {
		const getCardsData = () => {
			const cards = Array.from(document.getElementsByClassName('js-collection-featured-card'));

			const dataArray = [];
			cards.forEach(card => {
				const splitGalleryItems = () => {
					const gallery = card.dataset.gallery.split('+');
					gallery.pop();
					return gallery;
				}
	
				const createGalleryItemsArray = () => {
					const gallery = splitGalleryItems();
					const galleryItemArray = gallery.map((galleryItem) => {
						const galleryItemDetails = galleryItem.split('*');
						return {
							id: Number(galleryItemDetails[0]),
							image: galleryItemDetails[1],
							altText: galleryItemDetails[2]
						}
					});
					return galleryItemArray;
				}
				
				const parsedImageObject = () => {
					return JSON.parse(card.dataset.image);
				}

				const galleryObjectArray = createGalleryItemsArray();
				const newGallery = galleryObjectArray.filter(image => image.id !== parsedImageObject().id);
				const cardDataSet = {...card.dataset, image: parsedImageObject(), gallery: newGallery};
				dataArray.push(cardDataSet);
			});
			
			return dataArray;
		}
		
		const cardsDataArray = getCardsData(); 
		setModalContent(cardsDataArray);
	}, []);

	return [modalContent, setModalContent];
}

export default useFeaturedCardData;